export class Customer {
  constructor(props) {
    this.address = props['EListAddresClient'];
    this.phones = props['EListPhoneClient'];
    this.emails = props['EListEmailClient'];
  }
}
